<template>
  <v-container pa-0>
    <v-row>
      <div class="page__title">
        <h1>Twoja Karta</h1>
      </div>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card flat class="virtual-card-container">
          <card-view />

          <card-info />
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card flat class="account-groups-container">
          <h2 class="v-card-h2">
            Twoje grupy
          </h2>

          <ul class="my-3">
            <li v-for="(group, index) in groups" :key="'group_' + index">
              {{ group.name }}
              <i v-if="group.auto" class="mdi mdi-cog-refresh ml-2" />
            </li>
          </ul>

          <div class="d-flex align-center accound-groups-key pt-2">
            <i class="mdi mdi-cog-refresh mr-2" />
            <small>- Grupy nadane automatycznie</small>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import CardInfo from '@/components/cards/CardInfo';
import CardView from '@/components/cards/CardView';
import { LocalStorage } from '@/enums/storage.enum';
import { cardMixin } from '@/mixins/cardMixin';
import { displayModalMixin } from '@/mixins/displayModal';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Wyświetlanie kodu QR
// @group main
export default {
  components: {
    CardInfo,
    CardView
  },
  mixins: [cardMixin, displayModalMixin, notificationsMixin],
  data() {
    return {
      size: 300,
      blockDate: null,
      model: {}
    };
  },
  computed: {
    userId() {
      return localStorage.getItem(LocalStorage.USER_ID);
    },
    ...mapState({
      card: state => state.card.list[0],
      groups: state => {
        const groups = state.profile.groups;
        groups.unshift({ name: 'Posiadacze Usteckiej Karty Mieszkańca', auto: true });
        return groups;
      }
    })
  }
};
</script>
